import Dropdown from '@/compoments/common/Dropdown'
import DropdownList from '@/compoments/DropdownList'
import { useGetDispatcherCustomerFeedbacksQuery } from '@/services/dispatcher/dispather'
import { useParams, useSearchParams } from 'react-router-dom'
import DotsSvg from '@/assets/img/dots.svg'
import { format } from 'date-fns'

import clsx from 'clsx'
import {
    enumPillStatusesClasses,
    enumPillStatusesText,
} from '@/types/tenant/workGroup.types'
import UserPart from '@/compoments/common/UserPart'
import PageLoader from '@/compoments/PageLoader'

const FeedbackTab = () => {
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const queryString = searchParams.toString()
    const { data, isLoading } = useGetDispatcherCustomerFeedbacksQuery(
        {
            id: Number(id),
            query: `no_limit=true&${queryString}`,
        },
        { skip: !id || !searchParams.get('startDate') },
    )
    const pageData = data?.data
    if (isLoading) {
        return <PageLoader className="h-full" />
    }
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Service</th>
                    <th style={{ width: 250 }}>Feedback</th>
                    <th>Technician</th>
                    <th>Status</th>
                    <th style={{ width: 10 }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {pageData && pageData.feedbacks.length > 0 ? (
                    pageData.feedbacks.map((order, index) => (
                        <tr key={index}>
                            <td>
                                <span className="text-color-1">
                                    {format(order.startTime, 'MMM dd, yyyy')}
                                </span>
                            </td>
                            <td>{order.service.name}</td>
                            <td>
                                <span className="text--12 text-color-1 text-wrap">
                                    {order.feedback.comment}
                                </span>
                            </td>
                            <td>
                                <UserPart
                                    name={order.technician.fullName}
                                    src={order.technician.photo}
                                />
                            </td>
                            <td>
                                <span
                                    className={clsx(
                                        'pill',
                                        enumPillStatusesClasses[order.status],
                                    )}
                                >
                                    {enumPillStatusesText[order.status]}
                                </span>
                            </td>
                            <td className="text-right sticky-end">
                                <Dropdown
                                    closeSelf={true}
                                    dropdownClasses="flex flex-col"
                                    button={
                                        <span className="ico">
                                            <img src={DotsSvg} alt="" />
                                        </span>
                                    }
                                    menuClassName="dropdown-md"
                                    menu={<DropdownList list={[]} />}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={5}>
                            <h4 className="text-center">Feedbacks not found</h4>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export default FeedbackTab
